<template>
    <div class="row">
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-primary">Total Subtotal</span></h5>
              <h3 class="my-3">
                <span>{{ totalSubtotal | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-primary">Total Discount</span></h5>
              <h3 class="my-3">
                <span>{{ totalDiscount | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-warning">Total Rounding</span></h5>
              <h3 class="my-3">
                <span>{{ totalRounding | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Payment</span></h5>
              <h3 class="my-3">
                <span>
                  {{ totalPayment | currency }}
                </span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Tunai</span></h5>
              <h3 class="my-3">
                <span>{{ totalTunai | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Transfer</span></h5>
              <h3 class="my-3">
                <span>{{ totalTransfer | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Giro</span></h5>
              <h3 class="my-3">
                <span>{{ totalGiro | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Uang Muka</span></h5>
              <h3 class="my-3">
                <span>{{ totalUangMuka | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h5>Payment List</h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <div class="form-inline ml-auto">
                <div class="button-group">
                  <button type="button" class="btn btn-sm btn-soft-primary waves-light waves-effect" @click="addPayment">
                    <i class="fa fa-plus" aria-hidden="true"></i> New
                  </button>
                  <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshList">
                    <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                  </button>
                  <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                    <i class="fa fa-filter" aria-hidden="true"></i>
                      Filter
                      <span class="caret"></span>
                  </button>
                  <ul class="dropdown-menu p-2">
                    <span>Company:</span>
                    <div class="dropdown-divider"></div>
                    <li v-for="c in companyList" :key="c.id">
                      <a href="#" class="small" tabIndex="-1">
                        <input type="checkbox" :value="c.company_no" v-model="filterCompany"/>&nbsp; {{ c.name }}
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="button-group">
                  <button class="btn btn-warning btn-sm dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-print" aria-hidden="true"></i> Print</button>
                  <div class="dropdown-menu" aria-labelledby="print">
                    <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                    <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                  </div>
                </div>
                <div class="button-group">
                  <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshList"></date-picker>
                  rows:
                  <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                    <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                  </select>
                  <span class="mr-1">
                    Total rows: <b>{{ rowsTotal }}</b>
                  </span>
                </div>
                <div class="form-group mx-sm-3 mb-2">
                    <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                </div>
                <span class="mr-1">
                  page:
                  <select v-model="currentPage">
                    <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                  </select>
                  / {{ pageLength }}
                </span>
                <nav aria-label="Page navigation example" class="pull-right">
                    <ul class="pagination">
                        <li class="page-item">
                            <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                <i class="fa fa-angle-left" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li class="page-item">
                            <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                <i class="fa fa-angle-right" aria-hidden="true"></i>
                            </a>
                        </li>
                    </ul>
                </nav>
                <!-- <div class="button-group">
                  <button type="button" class="btn btn-sm btn-hard-primary" @click="viewChange('table')" v-if="view === 'table'"><i class="fa fa-table" aria-hidden="true"></i></button>
                  <button type="button" class="btn btn-sm btn-hard-outline-primary" @click="viewChange('table')" v-else><i class="fa fa-table" aria-hidden="true"></i></button>
                  <button type="button" class="btn btn-sm btn-hard-primary" @click="viewChange('grid')" v-if="view === 'grid'"><i class="fa fa-th-large" aria-hidden="true"></i></button>
                  <button type="button" class="btn btn-sm btn-hard-outline-primary" @click="viewChange('grid')" v-else><i class="fa fa-th-large" aria-hidden="true"></i></button>
                </div> -->
              </div>
              <table class="table table-item mb-0 table-sm table-hover table-striped">
                <thead>
                    <tr>
                        <th>
                          <label class="form-checkbox">
                            <input type="checkbox" v-model="selectAll" @click="select">
                            <i class="form-icon"></i>
                          </label>
                        </th>
                        <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                            {{ t.name }}
                            <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                  <tr v-if="filterData.length < 1">
                    <td colspan="19" style="text-align: center;"><i>No Data</i></td>
                  </tr>
                    <tr v-for="(u, index) in filterData" v-bind:key="u.id" @click="editPayment(u.id, index)" style="cursor: pointer" :class="index === idx ? 'trcolor' : null">
                      <td>
                        <label class="form-checkbox">
                          <input type="checkbox" :value="u.id" v-model="selected" class="custom--checkbox">
                          <i class="form-icon"></i>
                        </label>
                      </td>
                      <td>
                        <span class="badge badge-primary" v-if="u.status === 'approve'">{{ u.status }}</span>
                        <span class="badge badge-success" v-else>{{ u.status }}</span>
                      </td>
                      <td>
                        <span v-if="u.report_no !== null"><i class="fa fa-check" style="color: green"></i></span>
                      </td>
                      <td>{{ u.method }}</td>
                      <td><b>{{ u.group_no }}</b></td>
                      <td>{{ u.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                      <td>{{ u.prepayment_date | dateFormat('DD/MM/YYYY') }}</td>
                      <td>{{ u.finish_date | dateFormat('DD/MM/YYYY') }}</td>
                      <td>
                        <span v-if="u.payment_age >= 7" class="badge badge-danger">{{ u.payment_age }} day</span>
                        <span v-else-if="u.payment_date !== null"></span>
                        <span v-else>{{ u.payment_age }} day</span>
                      </td>
                      <td>{{ u.category }}</td>
                      <td>{{ u.vendor }}</td>
                      <td>
                        <span v-for="d in u.sales" :key="d.id">{{ d.sale_no }} </span>
                      </td>
                      <td>
                        <span v-for="d in u.sales" :key="d.id">{{ d.sale_date | dateFormat('DD/MM/YYYY') }} </span>
                      </td>
                      <td>{{ u.subtotal | currency }}</td>
                      <td>{{ u.discount | currency }}</td>
                      <td>{{ u.round | currency }}</td>
                      <td>
                        {{ u.total | currency }}
                      </td>
                      <td>
                        <span v-if="u.journal_count > 0"><i class="fa fa-check" style="color: green;"></i></span>
                      </td>
                    </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- <pre>{{ filterCategory }}</pre> -->
      <!-- <pre>{{ filterData }}</pre> -->
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { paymentUrl, purchasing2Url, getHeader } from '@/config'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'PaymentGroupList',
  components: {
    Loading,
    DatePicker
  },
  props: ['idx'],
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      filterCompany: [],
      startDate: [date1, date2],
      publicPath: process.env.BASE_URL,
      dateNow: new Date(),
      view: 'table',
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#6ED861',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      filterCategory: [],
      filterType: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1,
      title: [{
        name: 'Status',
        prop: 'status'
      }, {
        name: 'Report',
        prop: 'report_no'
      }, {
        name: 'Method',
        prop: 'method_id'
      }, {
        name: 'Payment No',
        prop: 'group_no'
      }, {
        name: 'Create Date',
        prop: 'payment_date'
      }, {
        name: 'Tgl. Giro',
        prop: 'prepayment_date'
      }, {
        name: 'Finish Date',
        prop: 'finish_date'
      }, {
        name: 'Count Day',
        prop: 'payment_age'
      }, {
        name: 'Category',
        prop: 'category'
      }, {
        name: 'Vendor',
        prop: 'vendor'
      }, {
        name: 'Sale No',
        prop: 'sale_no'
      }, {
        name: 'Sale Date',
        prop: 'sale_date'
      }, {
        name: 'Subtotal',
        prop: 'sutotal'
      }, {
        name: 'Discount',
        prop: 'discount'
      }, {
        name: 'Round',
        prop: 'round'
      }, {
        name: 'Total',
        prop: 'total'
      }, {
        name: 'Journal',
        prop: 'journal_count'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshList()
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList
    }),
    totalTunai () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].method_id === 1) {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    totalTransfer () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].method_id === 2) {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    totalGiro () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].method_id === 3) {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    totalUangMuka () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].method_id === 4) {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    totalSubtotal () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].subtotal)
      }
      return sum
    },
    totalPayment () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalDiscount () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].discount)
      }
      return sum
    },
    totalRounding () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].round)
      }
      return sum
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        if (this.filterCategory.length > 0) {
          for (let i = 0; i < this.filterCategory.length; i++) {
            if (d.category_id === this.filterCategory[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter(d => {
        for (var name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterCompany.length > 0) {
          for (let i = 0; i < this.filterCompany.length; i++) {
            if (d.company_no === this.filterCompany[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        var start = (this.currentPage - 1) * this.pageSize
        var end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    viewChange: function (v) {
      this.view = v
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (var i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    editPayment (id, index) {
      console.log(paymentUrl + '/' + id + '?status=purchasing')
      axios.get(paymentUrl + '/' + id + '?status=purchasing', { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          var data = {
            data: response.data.data,
            index: index
          }
          this.$emit('editPayment', data)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error!!!',
            error.response.data.message,
            'error'
          )
        })
    },
    addPayment () {
      this.$emit('newPayment', true)
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = paymentUrl + '?begin=' + begin + '&end=' + end + '&category=purchasing'
      console.log(url)
      axios.get(url, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.searchQuery = ''
          window.scrollTo(0, this.scroll)
        })
        .catch(error => {
          this.loader.isLoading = false
          this.$Progress.finish()
          console.log(error.response)
        })
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var data = {
        format: type,
        data: this.dataRaw,
        begin: begin,
        end: end
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      console.log(data)
      await axios.post(purchasing2Url + '/payment/print', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>
